import {useNavigate} from "react-router-dom";
import {useEffect} from "react";
import {Helmet} from "react-helmet";

// Public (non-secret) OAuth client ID. Override per-environment via REACT_APP_GOOGLE_CLIENT_ID
// (CRA bakes it in at build time). Falls back to the production client so prod builds are unaffected.
const GOOGLE_CLIENT_ID =
  process.env.REACT_APP_GOOGLE_CLIENT_ID ||
  "1079259030046-d3p8ghfgrb8r0l038848gquc174ug18b.apps.googleusercontent.com";


function LoginPage({setLogin, setUser, albert}) {
    const nav = useNavigate();

    const handleLoginSuccess = (result) => {
      localStorage.setItem("token", result.access_token);
      localStorage.setItem("userid", result.userid);
      localStorage.setItem("username", result.username);
      setLogin("התנתק");
      setUser({name: result.username, id: result.userid});
      albert("התחברת בהצלחה. ניתן להתחיל להזין את פרטי התמהילים שלך.");
      nav("/simulator");
    };

    const LogInWithGoogle = async (googleCredential) => {
          const response = await fetch('/api/login', {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({ id_token: googleCredential }),
          });

          if (!response.ok) {
            albert("בעיה בהתחברות עם גוגל.");
            throw new Error(`HTTP error! Status: ${response.status}`);
          }

          const result = await response.json();
          handleLoginSuccess(result);
        };

    // DEV ONLY: skip Google and get a local session. Rendered only in `npm start` builds;
    // the backend route is disabled when FLASK_ENV=production.
    const devLogin = async () => {
      const response = await fetch('/api/devlogin', {
        method: "POST",
        headers: {"Content-Type": "application/json"},
        body: JSON.stringify({}),
      });
      if (!response.ok) {
        albert("בעיה בהתחברות (dev).");
        return;
      }
      handleLoginSuccess(await response.json());
    };


      useEffect(() => {
        /* global google */
        if (window.google) {
          google.accounts.id.initialize({
            client_id: GOOGLE_CLIENT_ID,
            callback: LogInWithGoogle,
          });

          google.accounts.id.prompt();

          google.accounts.id.renderButton(
            document.getElementById("google-signin-button"),
            { theme: "outline", size: "large", width: 300 }
          );
        }
        // Google sign-in is initialised once on mount; the callback is stable for this purpose.
        // eslint-disable-next-line react-hooks/exhaustive-deps
      }, []);

  return (
    <div className="auth-page">
      <Helmet>
        <title>מחשבון משכנתא | משכנתא דאטה | התחברות לחשבון </title>
        <meta name="description" content="התחברו לחשבון על מנת לראות את התרחישים" />
      </Helmet>

      <div className="auth-card">
        <div className="auth-card-header">
          <div className="auth-logo"><i className="bi bi-houses"></i></div>
          <h2>כניסה לחשבונך</h2>
          <p>התחברו כדי להזין תמהילים ולצפות בתרחישים שלכם</p>
        </div>

        <div className="auth-google">
          <div id="google-signin-button"></div>
        </div>

        {process.env.NODE_ENV === "development" && (
          <button
            type="button"
            onClick={devLogin}
            style={{marginTop: 12, width: 300, padding: "8px 12px", cursor: "pointer"}}
          >
            כניסה מקומית (Dev) — דילוג על Google
          </button>
        )}

        <p className="auth-note">
          <i className="bi bi-shield-lock"></i>
          הכניסה מאובטחת דרך חשבון Google שלכם. איננו שומרים סיסמאות.
        </p>
      </div>
    </div>
  );
}

export default LoginPage;
